import {
  TableFirstPageIcon,
  TableLastPageIcon,
  TableNextPageIcon,
  TablePreviousPageIcon,
} from "../assets/svg";
import "./Pagination.scss";
import React from "react";

function TanstackPagination({ table, totalRows }) {
  const rowsPerPageArray = [25, 50, 100];
  const pageIndex = table.getState().pagination.pageIndex + 1;
  const pageCount = table.getPageCount();
  const pageSize = table.getState().pagination.pageSize;

  const recordsRangeFirst = pageIndex * pageSize - pageSize + 1;
  const recordsRangeLast = table.getCanNextPage()
    ? pageIndex * pageSize
    : totalRows;
  // const recordsTotal = pageCount * pageSize;

  return (
    <div className="pagination_container">
      <span className="go_to_page_wrapper">
        &nbsp;&nbsp;Go to page&nbsp;:&nbsp;
        <input
          className="input_box"
          type="number"
          defaultValue={pageIndex}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              const page = e.currentTarget.value
                ? Number(e.currentTarget.value) - 1
                : 0;
              table.setPageIndex(page);
            }
          }}
          style={{ width: "60px", textAlign: "center" }}
          min={1}
          max={table?.getPageCount()}
        />
        &nbsp;
      </span>

      <div className="rows_per_page">
        <span>Rows Per Page&nbsp;:&nbsp;</span>
        <select
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
        >
          {rowsPerPageArray.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {pageSize}
            </option>
          ))}
        </select>
      </div>

      <span>
        <span>Showing&nbsp;</span>
        <strong>
          {recordsRangeFirst} - {recordsRangeLast}{" "}
          <span style={{ fontWeight: "400" }}>of</span> {totalRows}
        </strong>
      </span>

      <span className="page_range">
        <span>&nbsp;Page&nbsp;</span>
        <strong>
          {pageIndex} <span style={{ fontWeight: "400" }}>of</span> {pageCount}
          &nbsp;
        </strong>
      </span>

      <div>
        <button
          title="First Page"
          className="pagination_btn"
          disabled={!table.getCanPreviousPage()}
          onClick={() => table.setPageIndex(0)}
        >
          <TableFirstPageIcon />
        </button>
        <button
          title="Previous Page"
          className="pagination_btn"
          disabled={!table.getCanPreviousPage()}
          onClick={() => table.previousPage()}
        >
          <TablePreviousPageIcon />
        </button>
        <button
          title="Next Page"
          className="pagination_btn"
          disabled={!table.getCanNextPage()}
          onClick={() => table.nextPage()}
        >
          <TableNextPageIcon />
        </button>
        <button
          title="Last Page"
          className="pagination_btn"
          disabled={!table.getCanNextPage()}
          onClick={() => table.setPageIndex(pageCount - 1)}
        >
          <TableLastPageIcon />
        </button>
      </div>
    </div>
  );
}

export default TanstackPagination;
